<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconTrash_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M5.9 2.3v.1H1.7a.7.7 0 1 0 0 1.4h12.6a.7.7 0 1 0 0-1.4h-4.2v-.1a2 2 0 0 0-2-2h-.2a2 2 0 0 0-2 2Z"
    />
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M13.6 5.2H2.4v8.5a2 2 0 0 0 2 2h7.2a2 2 0 0 0 2-2V5.2ZM7.3 8a.7.7 0 1 0-1.4 0v4.9a.7.7 0 1 0 1.4 0V8Zm2.1-.7a.7.7 0 0 1 .7.7v4.9a.7.7 0 0 1-1.4 0V8a.7.7 0 0 1 .7-.7Z"
        clip-rule="evenodd"
    />
</svg>
